import jQuery from "jquery";

jQuery(document).ready(function ($) {
  /* CONTACT FORM */
  var fnContactForm = function () {
    var prevalidateFields = function () {
      var printPrevalidationErrorTimeout = undefined;
      var printPrevalidationError = function ($field, message) {
        var html =
          '<span class="wpcf7-not-valid-tip" aria-hidden="true">' +
          message +
          "</span>";
        $field.parent().find(".wpcf7-not-valid-tip").remove();

        if (printPrevalidationErrorTimeout) {
          clearTimeout(printPrevalidationErrorTimeout);
        }

        printPrevalidationErrorTimeout = setTimeout(function () {
          $field.first("span").append(html);
        }, 300);
      };

      var preValidateFields = function ($form) {
        var $this = $form;
        var $fieldsToPrevalidate = $this.find("[data-prevalidate]");
        var passed = 0;

        $fieldsToPrevalidate.each(function () {
          var $_this = $(this);
          var inputValue = $_this.find("input, select, textarea").val();
          var regex = $_this.data("prevalidateregex");
          var errorText = $_this.data("prevalidateerror");
          let re = new RegExp(regex);
          let isMatch = re.test(inputValue);

          if (isMatch) {
            passed++;
          } else {
            printPrevalidationError($(this), errorText);
          }
        });

        if ($fieldsToPrevalidate.length == passed) {
          return true;
        } else {
          return false;
        }
      };

      $(".wpcf7-form").each(function () {
        var $this = $(this);
        var $btn = $this.find('input[type="submit"]');

        $this.on("submit", function (e) {
          e.preventDefault();
        });

        $btn.on("click", function (_e) {
          if (preValidateFields($this)) {
            $this.closest("form").submit();
          }
        });
      });
    };

    var initDataLayer = function () {
      $(".wpcf7-form").each(function () {
        var $this = $(this);
        let isFormInitiated = false;
        $this.find("input, select, textarea").on("focus", function () {
          if (!isFormInitiated) {
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "form_input",
              });
              isFormInitiated = true;
            } catch (e) {
              console.log(`DataLayer error`);
            }
          }
        });
      });
    };

    var updateCustomCheckbox = function () {
      // update fake checkbox
      $(".wpcf7-form-customRowCheckbox").each(function () {
        var $this = $(this);
        var $checkbox = $this.find('input[type="checkbox"]');
        var $fakeCheckbox = $this.find(".wpcf7-form-fakeCheckbox");

        $checkbox.change(function () {
          if ($checkbox.prop("checked") == true) {
            $fakeCheckbox.addClass("active");
          } else {
            $fakeCheckbox.removeClass("active");
          }
        });
      });
    };

    var clearInputField = function () {
      $(".wpcf7-form-reset-input").on("click", function () {
        $("#" + $(this).data("target")).val("");
      });
    };

    var fillContactFormSelectWithDefaultOption = function () {
      $(".wpcf7-form-customRow--select[data-emptyoption]").each(function () {
        var $this = $(this);
        var text = $this.data("emptyoption");

        $(this)
          .find("select")
          .prepend('<option value="" selected>' + text + "</option>");
      });
    };

    var contactShowHideField = function () {
      // need to re-adding row
      let $frmController = $("[data-optiontrigger]");
      let _classToLookup = $frmController.data("showhiderow");
      let trigger = $frmController.data("optiontrigger");
      let $showHideRow = $(_classToLookup);
      let $showHideRowHtml = $showHideRow.clone();

      const clearRow = function () {
        $showHideRow = $(_classToLookup); // need refresh var
        $showHideRow.remove();
      };

      clearRow(); // first clear

      // show hidden input on contact if some value selected
      $("[data-optiontrigger] select").change(function () {
        let $this = $(this);
        let $parent = $this.parent().parent().parent();

        clearRow(); // crear to prevent duplicate
        if ($this.val() === trigger) {
          $parent.after($showHideRowHtml);
        }
      });
    };

    var contactShowHideField2 = function () {
      // need to re-adding row
      let $frmController = $("[data-optiontrigger2]");
      let _classToLookup = $frmController.data("showhiderow2");
      let trigger = $frmController.data("optiontrigger2");
      let $showHideRow = $(_classToLookup);
      let $showHideRowHtml = $showHideRow.clone();

      const clearRow = function () {
        $showHideRow = $(_classToLookup); // need refresh var
        $showHideRow.remove();
      };

      clearRow(); // first clear
      // show hidden input on contact if some value selected
      $frmController.find("select").change(function () {
        let $this = $(this);
        let $parent = $this.parent().parent().parent();

        clearRow(); // crear to prevent duplicate

        if ($this.val() === trigger) {
          $parent.after($showHideRowHtml);
        }
      });
    };

    var formSubmitSuccessListener = function () {
      $(".form-messageSuccess").addClass("d-none");

      var $contact = $(".et_contact").parent().parent().get(0);
      var $contacts = $(".et_contact").parent().parent();

      if ($(".et_contact").length > 0) {
        if ($contacts.length > 0) {
          $(".et_contact")
            .parent()
            .parent()
            .each(function (index, element) {
              element.addEventListener(
                "wpcf7mailsent",
                function (event) {
                  try {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "form_submission",
                    });
                  } catch (e) {
                    console.log(`DataLayer error`);
                  }

                  $(".form-messageSuccess").removeClass("d-none");
                  $(".form-messageSuccess").addClass("success");

                  // add hash to url
                  const url = window.location.href;
                  if (url.indexOf("#") > -1) {
                    url = url.substring(0, url.indexOf("#"));
                  }
                  window.location.href = url + `#form-messageSuccess`;

                  $(".form-step").addClass("d-none");
                  showThankYouForActionWall();
                },
                false
              );
            });
        }

        $("input.wpcf7-submit").on("click", function () {
          $("input.wpcf7-submit").addClass("disabled");
          return this;
        });
        $contact.addEventListener(
          "wpcf7submit",
          function (event) {
            $("input.wpcf7-submit").removeClass("disabled");
          },
          false
        );
      }

      var $mbcontact = $(".mb_contact").parent().parent().get(0);

      if ($(".mb_contact").length > 0) {
        $mbcontact.addEventListener(
          "wpcf7mailsent",
          function (event) {
            $(".form-messageSuccess").removeClass("d-none");
            $(".form-messageSuccess").addClass("success");
            $(".mb_contact").hide();
            $(".wpcf7-response-output").addClass(
              "wpcf7-response-output-visible"
            );
            // add hash to url
            const url = window.location.href;
            if (url.indexOf("#") > -1) {
              url = url.substring(0, url.indexOf("#"));
            }
            window.location.href = url + `#form-messageSuccess`;
            showThankYouForActionWall();
          },
          false
        );

        $("input.wpcf7-submit").on("click", function () {
          $("input.wpcf7-submit").addClass("disabled");
          return this;
        });
        $mbcontact.addEventListener(
          "wpcf7submit",
          function (event) {
            $("input.wpcf7-submit").removeClass("disabled");
          },
          false
        );
      }
    };

    const showThankYouForActionWall = function () {
      if ($(".ex-action-wall .wpcf7").length > 0) {
        $(".ex-action-wall .wpcf7").addClass("d-none");

        const $fullVideo = $(".ex-action-wall .full-video").clone();
        $fullVideo.removeClass("d-none");
        $(".ex-action-wall .teaser-video").parent().append($fullVideo);
        $(".ex-action-wall .teaser-video")
          .parent()
          .find("iframe.teaser-video")
          .remove();

        $(".ex-action-wall .ex-action-wall__thank-you").removeClass("d-none");
        setCookie("EXATEL_AW", "1", 30);
      }
    };

    var enableListeners = function () {
      if ($(".et_contact").length > 0) {
        $(".wpcf7-character-count").bind("DOMSubtreeModified", function () {
          let c = $(".wpcf7-character-count").attr("data-current-value");
          let m = $(".wpcf7-character-count").attr("data-maximum-value");

          $(".wpcf7-form-control-wrap.your-message").attr(
            "data-value",
            c + " / " + m
          );
          // $('.wpcf7-form-control-wrap.your-message').setAttribute('data-value', c);
        });
      }
    };
    // prevalidateFields(); // no needs now
    updateCustomCheckbox();
    clearInputField();
    fillContactFormSelectWithDefaultOption();
    contactShowHideField();
    contactShowHideField2();
    formSubmitSuccessListener();
    enableListeners();
    initDataLayer();
  };
  /* CONTACT END */

  var setEvents = function () {};

  var setCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie =
      name + "=" + value + expires + "; path=/; SameSite=None; Secure";
  };

  var init = function () {
    setEvents();
    fnContactForm();
  };

  init();
});
